var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"js-enneagram-view"}},[_c('enneagram-display',{attrs:{"data":_vm.assessment,"userId":parseInt(_vm.userId),"isMember":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }